import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "js-cookie";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class PythonReportStore {
  loading = false;
  total = 0;
  pythonReportList = [];
  counts = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      pythonReportList: observable,
      counts: observable,
      loadData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData() {
    this.loading = true;
    var postData = {
     userId: JSON.parse(base64_decode(Cookies.get("data"))).userId
    };

    const response = await postApi
      .getClient("NodeCoreUrl")
      .get("/pythonReport/reportList", { params: postData });
   
    // console.log(response?.data?.data)
    this.pythonReportList = response?.data?.data?.ReportList;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.counts = response?.data?.data;
    this.loading = false;

    return response?.data?.data;
  }
}

export default PythonReportStore;
